import { Theme } from "js/core/models/theme";
import SharedThemesAdapter from "js/core/storage/sharedThemesAdapter";

const SharedTheme = Theme.extend({
    root: "sharedThemes",
    ensurePersisted: true,

    createAdapter: function(options) {
        return new SharedThemesAdapter({ ...options, model: this });
    }
});

export { SharedTheme };
